import { useQuery } from "@tanstack/react-query";
import ContainerService from "../services/Container/ContainerService";

export const useForwarders = () => {
    return useQuery({
        queryKey: ["forwarders"],
        queryFn: () => ContainerService.getForwarders().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};